module.exports = __webpack_public_path__ + "media/images/registry_banner-7f88187a44f4be529c3d1f910835e08f.jpg";